import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../../../../redux/epics/utils';
import { extractTableDataFromPayload } from '../../../../../../../common/components/table/utils/table_redux_payload_utils';
import { SEARCH_BUSINESS_COMPONENT_ENDPOINT } from '../../../../../../../common/config/api_endpoints';

const SEARCH_BUSINESS_COMPONENT_ACTION_TYPES = createAPILifecycleActionTypes(
  'SEARCH_BUSINESS_COMPONENT_ACTION_TYPES',
);
export const searchBusinessComponentActions = createAPILifecycleActions(
  SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.NAME,
);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          ...extractTableDataFromPayload(payload),
        },
        error: null,
      };
    case SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const searchBusinessComponentEpic = createAmplifyAPICallEpic({
  actionType: SEARCH_BUSINESS_COMPONENT_ACTION_TYPES.BEGIN,
  api: SEARCH_BUSINESS_COMPONENT_ENDPOINT,
  successCallback: response => [searchBusinessComponentActions.SUCCESS(response.body)],
  errorCallback: () => [searchBusinessComponentActions.FAILURE()],
});
